import script from "./HistoryList.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryList.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryList.vue?vue&type=style&index=0&id=340a5293&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340a5293"]])

export default __exports__